document.addEventListener('teeinblue-event-component-injected', function() {
    const formContainer = document.querySelector('#teeFormInputs');
    if(!formContainer) return;

    /* ====== Function toggle recustomize button ====== */
    function toggleRecustomizeButtons() {
        const photoFields = formContainer.querySelectorAll('.tee-field--photo');
        if(photoFields.length > 0) {
            photoFields.forEach(field => {
                const hasImage = !!field.querySelector('.tee-photo-image');
                const recustomizeBtn = field.querySelector('.tee-btn--recustomize');
                if (recustomizeBtn) {
                    recustomizeBtn.style.display = hasImage ? '' : 'none';
                }
            });
        }
    }

    /* ====== MutationObserver DOM ====== */
    const observerTIB = new MutationObserver(() => {
        toggleRecustomizeButtons();
    });

    observerTIB.observe(document.body, {
        childList: true,
        subtree: true
    });

    /* ====== Patch fetch with cart/add.js only ====== */
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
        if (typeof input === "string" && input.includes("/cart.js")) {
            const response = await originalFetch.apply(this, arguments);

            try {
                const clone = response.clone();
                clone.json().then(data => {
                    if(window.teeinblue) window.teeinblue.resetCustomization(window.teeinblueCampaign.productId);

                    toggleRecustomizeButtons();
                });
            } catch (e) {
                console.warn("[Intercept] Response not JSON:", e);
            }

            return response;
        }

        return originalFetch.apply(this, arguments);
    };

    toggleRecustomizeButtons();
})